
import { listadoTraslados } from '../../../components/Traslados/RegistrarTraslados';
import {
    LISTA_TRASPASOS_ENVIADOS_REQUEST,
    LISTA_TRASPASOS_ENVIADOS_SUCCESS,
    LISTA_TRASPASOS_ENVIADOS_FAIL
} from '../../actions/Traspasos/types'

// Define el tipo para el estado inicial
interface PropsState {
    listadoTraspasosEnviados: listadoTraslados[];
}
// Estado inicial tipado
const initialState: PropsState = {
    listadoTraspasosEnviados: []
};

// Reducer con tipos definidos
const listadoTraspasosEnviadosReducers = (state = initialState, action: any) => {
    switch (action.type) {
        case LISTA_TRASPASOS_ENVIADOS_REQUEST:
            return { ...state, loading: true };
        case LISTA_TRASPASOS_ENVIADOS_SUCCESS:
            return {
                ...state,
                loading: false,
                listadoTraspasosEnviados: action.payload,
            };
        case LISTA_TRASPASOS_ENVIADOS_FAIL:
            return {
                ...state, loading: false,
                error: action.error,
                listadoTraspasos: []
            };
        default:
            return state;
    }
};



export default listadoTraspasosEnviadosReducers;
